window.cinebody = window.cinebody || {};

cinebody.cacheSelectors = function () {
  cinebody.cache = {
    // General
    $window: $(window),

    // Feature Callouts
    $textCallout: $('.features-text').find('.callout'),
    $imageCallout: $('.features-image').find('.callout'),

    // Animated Header
    $sectionTrigger: $('.hero').height(),
    $logo: $('.cinebody-lockup-link'),

		// Secondary Nav
		$hamburger: $('.hamburger'),

		// Mailing List
		$mailingListForm: $('#mc-embedded-subscribe-form'),
		$emailInputWrapper: $('.email-input__wrapper'),
		$emailInput: $('.email-input'),
		$emailInputFieldName: $('.email-input__field-name'),
		$emailInputErrorText: $('.email-input__error-text')
  };
};

cinebody.featureCallouts = function() {
  var $textCallout = cinebody.cache.$textCallout,
      $imageCallout = cinebody.cache.$imageCallout;

  $textCallout.on('mouseenter mouseleave touchstart', function() {
    $('.features-image').find('.callout').eq($(this).data('index') - 1).toggleClass('active');
  });

  $imageCallout.on('mouseenter mouseleave touchstart', function() {
    $('.features-text').find('.callout').eq($(this).data('index') - 1).toggleClass('active');
  });
}

// cinebody.animatedHeader = function() {
//   var $window = cinebody.cache.$window,
//       $sectionTrigger = cinebody.cache.$sectionTrigger,
//       $logo = cinebody.cache.$logo;
//
//   $window.on('scroll', function() {
//     var scrollTop = $(window).scrollTop();
//     if ( scrollTop > $sectionTrigger ) {
//       $logo.css('-webkit-transform', 'translate(0,0)');
//       $logo.css('transform', 'translate(0,0)');
//     } else if ( scrollTop < $sectionTrigger ){
//       $logo.css('-webkit-transform', 'translate(-41px,0)');
//       $logo.css('transform', 'translate(-41px,0)');
//     }
//   });
// }

cinebody.toggleSecondaryNav = function() {
	var $hamburger = cinebody.cache.$hamburger;

	$hamburger.on('click', function() {
		if ($('body').hasClass('js-nav-is-open')) {
			$('body').removeClass('js-nav-is-open');
		} else {
			$('body').addClass('js-nav-is-open');
		}
	});
}

cinebody.playGIFs = function() {
  var $window = cinebody.cache.$window;

  $window.on('scroll', function() {
    var scrollTop = $(window).scrollTop() + $(window).height();

    $('.how-panel').each(function() {
      var animation = $(this).find('.how-image img').offset().top;
      var animationHeight = $(this).find('.how-image img').height();
      var animationTrigger = animation + (animationHeight / 4);
      var textTrigger = animationTrigger + 500;
      var imageSource = $(this).find('.how-image img')[0].src;
      if ( scrollTop > animationTrigger && scrollTop < textTrigger) {
        $(this).find('.how-text h3').addClass('hover');
        if (/gif/i.test(imageSource)) {
          return true;
        } else {
          $(this).find('.how-image img')[0].src = imageSource.replace('.jpg', '.gif');
          $(this).addClass('active');
        }
      } else {
        $(this).find('.how-text h3').removeClass('hover');
      }
    });
  });
}

cinebody.toggleFieldLabel = function(e) {
	var input = e.currentTarget;
	var inputValue = input.value;
	var inputWrapper = input.parentNode;

	if (inputValue.length > 0 && !$(inputWrapper).hasClass('js-label-is-visible')) {
		$(inputWrapper).addClass('js-label-is-visible');
	}

	if (inputValue.length === 0 && $(inputWrapper).hasClass('js-label-is-visible')) {
		$(inputWrapper).removeClass('js-label-is-visible');
	}
}

cinebody.init = function () {
  cinebody.cacheSelectors();
  cinebody.featureCallouts();
  // cinebody.animatedHeader();
  cinebody.playGIFs();
	cinebody.toggleSecondaryNav();
	var $emailInput = cinebody.cache.$emailInput;

	$emailInput.on('focus', function() {
		$emailInput.on('keyup', cinebody.toggleFieldLabel);
	});

	$emailInput.on('blur', function() {
		$emailInput.off('keyup', cinebody.toggleFieldLabel);
	})
};

$(cinebody.init);
